(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('S3FileExplorerController', S3FileExplorerController);

    S3FileExplorerController.$inject = ['S3FileExplorerService', '$http'];

    function S3FileExplorerController(S3FileExplorerService, $http) {
        var vm = this;
        vm.storageSystems = [
            { key: 's2', label: 'Temporaire (s2)' },
            { key: 's1', label: 'Persistant (s1)' }
        ];
        vm.storageSystem = 's2';
        vm.prefix = '';
        vm.breadcrumb = [];
        vm.folders = [];
        vm.files = [];
        vm.searchText = '';
        vm.nextToken = null;
        vm.truncated = false;
        vm.directoryCounts = [];
        vm.directoryCountsLoaded = false;
        vm.directoryCountsLoading = false;

        vm.enter = enter;
        vm.goUp = goUp;
        vm.download = download;
        vm.refresh = refresh;
        vm.loadMore = loadMore;
        vm.filteredFiles = filteredFiles;
        vm.loadDirectoryCounts = loadDirectoryCounts;
        vm.changeStorageSystem = changeStorageSystem;
        vm.currentStorageSystemLabel = currentStorageSystemLabel;

        activate();

        function activate() {
            resetExplorer();
        }

        function refresh() {
            resetDirectoryCounts();
            S3FileExplorerService.list(vm.storageSystem, vm.prefix).then(function(data) {
                vm.folders = data.prefixes || [];
                vm.files = data.files || [];
                vm.truncated = data.truncated;
                vm.nextToken = data.nextContinuationToken;
            });
        }

        function loadMore() {
            if (!vm.truncated) return;
            S3FileExplorerService.list(vm.storageSystem, vm.prefix, vm.nextToken).then(function(data) {
                vm.folders = unique(vm.folders.concat(data.prefixes || []));
                vm.files = vm.files.concat(data.files || []);
                vm.truncated = data.truncated;
                vm.nextToken = data.nextContinuationToken;
            });
        }

        function unique(values) {
            return values.filter(function(value, index, array) {
                return array.indexOf(value) === index;
            });
        }

        function filteredFiles() {
            if (!vm.searchText) return vm.files;
            var text = vm.searchText.toLowerCase();
            return vm.files.filter(function(file) {
                var name = file.key.split('/').slice(-1)[0].toLowerCase();
                return name.indexOf(text) !== -1;
            });
        }

        function buildBreadcrumb() {
            var crumbs = [{ name: '/', prefix: '' }];
            if (!vm.prefix) {
                vm.breadcrumb = crumbs;
                return;
            }

            var parts = vm.prefix.split('/').filter(Boolean);
            var accum = '';
            parts.forEach(function(part) {
                accum = accum ? (accum + '/' + part) : part;
                crumbs.push({ name: part, prefix: accum });
            });
            vm.breadcrumb = crumbs;
        }

        function resetExplorer() {
            vm.prefix = '';
            vm.folders = [];
            vm.files = [];
            vm.truncated = false;
            vm.nextToken = null;
            buildBreadcrumb();
            refresh();
        }

        function resetDirectoryCounts() {
            vm.directoryCounts = [];
            vm.directoryCountsLoaded = false;
        }

        function currentStorageSystemLabel() {
            var current = vm.storageSystems.filter(function(item) {
                return item.key === vm.storageSystem;
            })[0];
            return current ? current.label : vm.storageSystem;
        }

        function changeStorageSystem() {
            resetExplorer();
        }

        function enter(folderName) {
            if (!vm.prefix) {
                vm.prefix = folderName;
            } else {
                vm.prefix = vm.prefix.replace(/\/$/, '') + '/' + folderName;
            }
            buildBreadcrumb();
            refresh();
        }

        function goUp(prefix) {
            vm.prefix = prefix || '';
            buildBreadcrumb();
            refresh();
        }

        function download(item) {
            var url = S3FileExplorerService.downloadUrl(vm.storageSystem, item.key);
            $http.get(url, { responseType: 'arraybuffer' }).then(function(response) {
                var blob = new Blob([response.data], { type: response.headers('Content-Type') });
                var filename = getFileNameFromHeader(response.headers('Content-Disposition')) || item.name;

                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            });
        }

        function getFileNameFromHeader(disposition) {
            if (!disposition) return null;
            var match = disposition.match(/filename="(.+)"/);
            return match ? match[1] : null;
        }

        function loadDirectoryCounts() {
            vm.directoryCountsLoading = true;
            S3FileExplorerService.directoryCounts(vm.storageSystem, vm.prefix).then(function(data) {
                vm.directoryCounts = data || [];
                vm.directoryCountsLoaded = true;
            }).finally(function() {
                vm.directoryCountsLoading = false;
            });
        }
    }
})();
